module.exports = __webpack_public_path__ + "static/media/ahora30mg.b10fda46.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-alambrico/ahora30mg.png
// module id = 194
// module chunks = 0